module.exports = __webpack_public_path__ + "static/PSS-icon-08-7ab102fa5e8a98aaf413791c9cf936a6.png";